import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("NTicket")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Events")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("My Tickets")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Events Management")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("© NTicket, 2022")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_AMenuItem = _resolveComponent("AMenuItem")!
  const _component_AMenu = _resolveComponent("AMenu")!
  const _component_ALayoutHeader = _resolveComponent("ALayoutHeader")!
  const _component_RouterView = _resolveComponent("RouterView")!
  const _component_ALayoutContent = _resolveComponent("ALayoutContent")!
  const _component_ALayoutFooter = _resolveComponent("ALayoutFooter")!
  const _component_ALayout = _resolveComponent("ALayout")!

  return (_openBlock(), _createBlock(_component_ALayout, { class: "app-layout" }, {
    default: _withCtx(() => [
      _createVNode(_component_ALayoutHeader, { class: "header" }, {
        default: _withCtx(() => [
          _createVNode(_component_RouterLink, {
            class: "logo header__logo",
            to: "/"
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_component_AMenu, {
            selectedKeys: _ctx.selectedKeys,
            "onUpdate:selectedKeys": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedKeys) = $event)),
            theme: "dark",
            mode: "horizontal",
            style: { lineHeight: '64px' }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_AMenuItem, {
                key: "1",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.push('/events')))
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }),
              _createVNode(_component_AMenuItem, {
                key: "2",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.router.push('/my-tickets')))
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }),
              _createVNode(_component_AMenuItem, {
                key: "3",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.router.push('/events-management')))
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["selectedKeys"])
        ]),
        _: 1
      }),
      _createVNode(_component_ALayoutContent, { class: "app-layout__content" }, {
        default: _withCtx(() => [
          _createVNode(_component_RouterView)
        ]),
        _: 1
      }),
      _createVNode(_component_ALayoutFooter, null, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}